const sectionMarqueeBasicTextCss = `
[data-type='section-marquee-basic-text'] [data-attribute='marquee-basic-text-container'] {
  padding: 16px 0 8px;
}

[data-type='section-marquee-basic-text'] .marquee-basic-text-wrapper .grid-group {
  display: flex;
}

[data-type='section-marquee-basic-text'] .marquee-basic-text-wrapper .grid-group .wrap-item {
  margin-right: 40px;
  flex-shrink: 0;
  display: flex;
  gap: 40px;
}

[data-type='section-marquee-basic-text'] .marquee-basic-text-wrapper .grid-group .wrap-item .item-text {
  display: flex;
  align-items: center;
  font-size: 17px;
}

@container (max-width: 768px) {
  [data-type='section-marquee-basic-text'] .marquee-basic-text-wrapper .grid-group .wrap-item .item-text {
    font-size: 14px;
  }
}
`;

export default sectionMarqueeBasicTextCss;
